module.exports = __webpack_public_path__ + "img/trafficgeneration.5bd91ed3.jpg";